/**
 * Camera capability detection utilities
 *
 * Uses only enumerateDevices (no getUserMedia) so it never triggers a
 * permission prompt. In-app browsers (Instagram, Facebook, etc.) often
 * re-prompt for every getUserMedia call, so this keeps the count at zero.
 */

export type CameraInfo = {
  hasCamera: boolean;
  cameras?: MediaDeviceInfo[];
};

export async function getCameraInfo(): Promise<CameraInfo> {
  if (
    typeof window === "undefined" ||
    typeof navigator === "undefined" ||
    typeof navigator.mediaDevices === "undefined"
  ) {
    return { hasCamera: false };
  }

  try {
    const devices = await navigator.mediaDevices.enumerateDevices();
    const cameras = devices.filter((d) => d.kind === "videoinput");

    if (cameras.length === 0) {
      return { hasCamera: false };
    }

    return { hasCamera: true, cameras };
  } catch {
    return { hasCamera: false };
  }
}
